import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import ScrollReveal from '../components/ScrollReveal';
import AnimatedBackground from '../components/AnimatedBackground';
import { Shield } from 'lucide-react';

const PrivacyPolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-[#1E2A38] overflow-hidden">
        <AnimatedBackground className="opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1E2A38]/50 to-[#1E2A38]" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <ScrollReveal>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-[#0066CC]/20 flex items-center justify-center">
                <Shield className="w-6 h-6 text-[#0066CC]" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-white">
                {t('legal.privacyPolicy.title')}
              </h1>
            </div>
            <p className="text-white/70 text-lg">
              {t('legal.privacyPolicy.lastUpdated')}
            </p>
            <div className="w-24 h-1 bg-[#0066CC] rounded-full mt-8" />
          </ScrollReveal>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            {t('legal.privacyPolicy.sections').map((section, index) => (
              <ScrollReveal key={index} delay={index * 100}>
                <div className="mb-12">
                  <h2 className="text-2xl font-bold text-[#2B3A4D] mb-4">
                    {section.title}
                  </h2>
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex} className="text-[#5C5C5C] leading-relaxed mb-4">
                      {paragraph}
                    </p>
                  ))}
                  {section.list && (
                    <ul className="list-disc list-inside space-y-2 text-[#5C5C5C] ml-4">
                      {section.list.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Contact Information */}
          <ScrollReveal delay={600}>
            <div className="mt-16 p-8 bg-[#F8F9FA] rounded-2xl border border-[#E5E7EB]">
              <h3 className="text-xl font-bold text-[#2B3A4D] mb-4">
                {t('legal.privacyPolicy.contactTitle')}
              </h3>
              <p className="text-[#5C5C5C] mb-4">
                {t('legal.privacyPolicy.contactText')}
              </p>
              <div className="space-y-2 text-[#5C5C5C]">
                <p><strong>HITECH GROUP</strong></p>
                <p>2323 Chemin de Saint-Bernard</p>
                <p>06220 Vallauris, France</p>
                <p>Email: <a href="mailto:contact@hitech-group.io" className="text-[#0066CC] hover:underline">contact@hitech-group.io</a></p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
